import React from 'react'
import styles from './NoticeBar.scss'
import {Icon} from 'common/Icon'
import cx from 'classnames'

export class NoticeBar extends React.PureComponent {
  render () {
    const {children, className, onRequestClose, ...props} = this.props
    return (
      <div className={cx(styles.NoticeBar, className)} {...props}>
        <div className={styles.content}>
          <div className={styles.text}>
            {children}
          </div>
          {onRequestClose && <div className={styles.dismiss}>
            <Icon size={24} onClick={onRequestClose} i='ios-close-circle-outline' className={styles.dismissButton} />
          </div>}
        </div>
      </div>
    )
  }
}
